import { initializeApp } from 'firebase/app';
import { getFirestore, collection, addDoc, getDocs, query, orderBy, serverTimestamp, doc, setDoc, getDoc } from 'firebase/firestore';
import { getAuth, createUserWithEmailAndPassword, signInWithEmailAndPassword, signOut, onAuthStateChanged } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyCtLF_i5d_ag-O3iXswhU-8Vw34O-YbVdk",
  authDomain: "finlybooks-cf0b3.firebaseapp.com",
  projectId: "finlybooks-cf0b3",
  storageBucket: "finlybooks-cf0b3.firebasestorage.app",
  messagingSenderId: "610839930952",
  appId: "1:610839930952:web:23cd9714ee3d19ca03107d"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);

// Auth functions
export const registerUser = async (email, password, businessData) => {
  const cred = await createUserWithEmailAndPassword(auth, email, password);
  await setDoc(doc(db, 'users', cred.user.uid), {
    ...businessData,
    email,
    uid: cred.user.uid,
    registeredAt: serverTimestamp(),
    platform: 'web',
    appVersion: '1.0.0',
    marketingConsent: true,
  });
  return cred.user;
};

export const loginUser = (email, password) => signInWithEmailAndPassword(auth, email, password);
export const logoutUser = () => signOut(auth);
export const onAuthChange = (cb) => onAuthStateChanged(auth, cb);

// Firestore functions
export const saveData = async (uid, collection_name, data) => {
  return await addDoc(collection(db, 'users', uid, collection_name), { ...data, createdAt: serverTimestamp() });
};

export const getData = async (uid, collection_name) => {
  const q = query(collection(db, 'users', uid, collection_name), orderBy('createdAt', 'desc'));
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
};

export const getUserProfile = async (uid) => {
  const snap = await getDoc(doc(db, 'users', uid));
  return snap.exists() ? snap.data() : null;
};

// Update (merge) the user's business profile — used for company details & logo
export const updateUserProfile = async (uid, data) => {
  return await setDoc(doc(db, 'users', uid), data, { merge: true });
};

export const getAllUsers = async () => {
  const snap = await getDocs(collection(db, 'users'));
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
};

// Admin check
export const ADMIN_EMAIL = 'info@finlybooks.com';
